<template>
    <div class="page add-info">

        <div class="title">
            完善个人信息
        </div>

        <div class="warning" v-if="from_update && firstWarning">
            老朋友您好，欢迎回来，认证界面进行了一些改版，建议重新完善个人信息，如无需修改，您可点击完成。
        </div>

        <van-form class="add-info-form" @submit="onSubmit">

            <van-field
                required
                label-class="form-title"
                input-align="right"
                v-model="formData.name"
                name="您的姓名"
                label="您的姓名"
                placeholder="您的姓名"
                :rules="[{ required: true }]"
            />

            <van-field
                required
                label-class="form-title"
                input-align="right"
                name="radio"
                label="您的性别">
                <template #input>
                    <van-radio-group class="form-sex" v-model="formData.sex" direction="horizontal">
                        <van-radio name="男" checked-color="#0FB7AD">男</van-radio>
                        <van-radio name="女" checked-color="#0FB7AD">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>

            <van-field
                required
                label-class="form-title"
                name="radio"
                label="您的身份"
                :border="false"
                disabled>
            </van-field>

            <van-radio-group class="form-position-left" v-model="formData.identity" @change="changeIdentity">
                <van-radio name="1" checked-color="#0FB7AD" @click="clickIdentify(1)">患者本人</van-radio>
                <van-radio name="2" checked-color="#0FB7AD" @click="clickIdentify(2)">患者家属</van-radio>
                <van-row style="margin-top: 10px">
                    <van-col span="8">
                        <van-radio name="4" @click="clickIdentify(4)" checked-color="#0FB7AD" v-if="from_update || !is_apply || from_update">其他</van-radio>
                    </van-col>
                    <van-col span="16">
                        <div style="margin-top: -8px" v-if="formData.identity == 4 && (!is_apply || from_update)">
                            <van-field
                                label-class="form-title"
                                input-align="right"
                                clickable
                                readonly
                                name="picker"
                                :value="formData.identity_name"
                                placeholder="请选择"
                                right-icon="arrow"
                                :rules="[{ required: true }]"
                                @click="identityPicker = true"
                                v-if="(formData.identity == 4 )"
                            />
                        </div>
                    </van-col>
                </van-row>
            </van-radio-group>

            <div class="sm" v-if="formData.identity == 1 || formData.identity == 2">
                <span v-if="is_apply">此项目需要您补充患者真实信息，信息将严格保密：</span>
                <span v-else>为提供优质健康服务请您补充，信息将严格保密：</span>
            </div>

            <div v-if="formData.identity == 1 && !is_apply">
                <van-field
                    label-class="form-title"
                    input-align="right"
                    clickable
                    readonly
                    required
                    name="picker"
                    label="确诊疾病"
                    placeholder="请选择"
                    :value="'已选择'+formData.diagnose_name.length+'项'"
                    right-icon="arrow"
                    :rules="[{ required: true }]"
                    @click="openDiagnoseModel()"
                />
                <div class="form-diagnose">
                    <span class="true" @click="openDiagnoseModel()" v-for="item in formData.diagnose_name">{{ item }}</span>
                </div>

                <van-field required
                           label-class="form-title"
                           :label-width="200"
                           name="radio"
                           label="经历的治疗方式"
                           :border="false"
                           disabled>
                </van-field>
                <div class="form-diagnose">
                    <span :class="item.checked ? 'true' : 'false'" v-for="item in treatment" @click="chooseTreatment(item)">{{ item.name }}</span>
                </div>
            </div>


            <div v-if="formData.identity == 2 && !is_apply" style="padding-bottom: 20px">

                <div v-for="(patient,i) in formData.patients" style="margin-top: 20px">

                    <div v-if="patient.display">
                        <van-field
                            required
                            label-class="form-title"
                            input-align="right"
                            v-model="patient.name"
                            name="患者姓名"
                            label="患者姓名"
                            placeholder="患者姓名"
                            :rules="[{ required: true }]"
                        />

                        <van-field
                            label-class="form-title"
                            input-align="right"
                            clickable
                            readonly
                            required
                            name="picker"
                            label="确诊疾病"
                            placeholder="请选择"
                            :value="'已选择'+patient.diagnose_name.length+'项'"
                            right-icon="arrow"
                            :rules="[{ required: true }]"
                            @click="openPatientDiagnoseModel(i)"
                        />
                        <div class="form-diagnose">
                            <span class="true" @click="openPatientDiagnoseModel(i)" v-if="item!=''" v-for="item in patient.diagnose_name">{{ item }}</span>
                        </div>

                        <van-field required
                                   label-class="form-title"
                                   :label-width="200"
                                   name="radio"
                                   label="经历的治疗方式"
                                   :border="false"
                                   disabled></van-field>
                        <div class="form-diagnose">
                            <span :class="item.checked ? 'true' : 'false'" v-for="item in patient.treatment" @click="choosePatientTreatment(item,i)">{{ item.name }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!--医生-->
            <div v-if="formData.identity_name == '医务工作者'  && (!is_apply || from_update)">
                <van-field
                    required
                    label-class="form-title"
                    input-align="right"
                    clickable
                    readonly
                    name="picker"
                    right-icon="arrow"
                    :value="formData.hospital"
                    label="就职单位"
                    placeholder="请选择"
                    @click="chooseHospital()"
                />

                <van-field
                    required
                    label-class="form-title"
                    input-align="right"
                    clickable
                    readonly
                    name="picker"
                    :value="formData.position"
                    label="职务/职称"
                    placeholder="请选择"
                    right-icon="arrow"
                    @click="positionPicker = true"
                />
            </div>
            <div v-else-if="(!is_apply || from_update) && ['医疗企业相关人士','公益组织','媒体'].includes(formData.identity_name)">
                <van-field
                    required
                    label-class="form-title"
                    input-align="right"
                    v-model="formData.hospital"
                    name="就职单位"
                    label="就职单位"
                    placeholder="请填写"
                    :rules="[{ required: true }]"
                />
                <van-field
                    required
                    label-class="form-title"
                    input-align="right"
                    v-model="formData.position"
                    name="职务职称"
                    label="职务职称"
                    placeholder="请填写"
                    :rules="[{ required: true }]"
                />
            </div>

            <div v-if="(is_apply || from_update)">
                <!--患者-->
                <div v-if="formData.identity == 1">
                    <van-field
                        required
                        label-class="form-title"
                        input-align="right"
                        v-model="formData.identity_card_no"
                        name="您的身份证号"
                        label="您的身份证号"
                        placeholder="您的身份证号"
                        :rules="[{ required: true }]"
                    />

                    <van-field
                        required
                        label-class="form-title"
                        input-align="right"
                        clickable
                        readonly
                        name="picker"
                        :value="formData.hospital"
                        label="目前就诊医院"
                        placeholder="请选择"
                        right-icon="arrow"
                        :rules="[{ required: true }]"
                        @click="chooseHospital()"
                    />

                    <van-field
                        label-class="form-title"
                        input-align="right"
                        clickable
                        readonly
                        required
                        name="picker"
                        label="确诊疾病"
                        placeholder="请选择"
                        :value="'已选择'+formData.diagnose_name.length+'项'"
                        right-icon="arrow"
                        :rules="[{ required: true }]"
                        @click="openDiagnoseModel()"
                    />
                    <div class="form-diagnose">
                        <span class="true" @click="openDiagnoseModel()" v-if="item != ''" v-for="item in formData.diagnose_name">{{ item }}</span>
                    </div>

                    <van-field required
                               label-class="form-title"
                               :label-width="200"
                               name="radio"
                               label="经历的治疗方式"
                               :border="false"
                               disabled
                    ></van-field>
                    <div class="form-diagnose">
                        <span :class="item.checked ? 'true' : 'false'" v-for="item in treatment" @click="chooseTreatment(item)">{{ item.name }}</span>
                    </div>

                    <van-field
                        required
                        label-class="form-title"
                        name="radio"
                        label="所处治疗阶段"
                        :border="false"
                        disabled
                    />

                    <div class="form-diagnose">
                        <span :class="item.checked ? 'true' : 'false'" v-for="(item,i) in treatment_phase" @click="chooseTreatmentPhase(item,i)">{{ item.text }}</span>
                    </div>
                </div>
                <!--患者家属-->
                <div v-else-if="formData.identity == 2" style="padding-bottom: 20px">

                    <div v-for="(patient,i) in formData.patients" style="margin-top: 20px">

                        <div class="patient-header">
                            <div class="patient-header-title">患者{{hanz[i]}}</div>
                            <div class="patient-header-btn-box">
                                <div class="patient-header-btn" @click="deletePatient(i)">删除 <img src="/static/bytx/add_info_del.svg" alt=""></div>
                                <div class="patient-header-btn" @click="patient.display=true" v-if="!patient.display">展开 <img src="/static/bytx/add_info_down.svg" alt=""></div>
                                <div class="patient-header-btn" @click="patient.display=false" v-else>收起 <img src="/static/bytx/add_info_up.svg" alt=""></div>
                            </div>
                            <div class="clear"></div>
                        </div>

                        <div v-if="patient.display">
                            <van-field
                                required
                                label-class="form-title"
                                input-align="right"
                                v-model="patient.name"
                                name="患者姓名"
                                label="患者姓名"
                                placeholder="患者姓名"
                                :rules="[{ required: true }]"
                            />

                            <van-field
                                required
                                label-class="form-title"
                                input-align="right"
                                name="radio"
                                label="患者性别">
                                <template #input>
                                    <van-radio-group class="form-sex" v-model="patient.sex" direction="horizontal">
                                        <van-radio name="男" checked-color="#0FB7AD">男</van-radio>
                                        <van-radio name="女" checked-color="#0FB7AD">女</van-radio>
                                    </van-radio-group>
                                </template>
                            </van-field>

                            <van-field
                                required
                                label-class="form-title"
                                input-align="right"
                                label-width="120"
                                v-model="patient.identity_card_no"
                                name="患者身份证号"
                                label="患者身份证号"
                                placeholder="患者身份证号"
                                :rules="[{ required: true }]"
                            />

                            <van-field
                                required
                                label-class="form-title"
                                input-align="right"
                                clickable
                                label-width="160"
                                readonly
                                name="picker"
                                :value="patient.hospital"
                                label="患者最新的就诊医院"
                                placeholder="请选择"
                                :rules="[{ required: true }]"
                                @click="choosePatientHospital(i)"
                            />

                            <van-field
                                label-class="form-title"
                                input-align="right"
                                clickable
                                readonly
                                required
                                name="picker"
                                label="确诊疾病"
                                placeholder="请选择"
                                :value="'已选择'+patient.diagnose_name.length+'项'"
                                right-icon="arrow"
                                :rules="[{ required: true }]"
                                @click="openPatientDiagnoseModel(i)"
                            />
                            <div class="form-diagnose">
                                <span class="true" @click="openPatientDiagnoseModel(i)" v-for="item in patient.diagnose_name">{{ item }}</span>
                            </div>

                            <van-field required
                                       label-class="form-title"
                                       :label-width="200"
                                       name="radio"
                                       label="经历的治疗方式"
                                       :border="false"
                                       disabled
                            ></van-field>
                            <div class="form-diagnose">
                                <span :class="item.checked ? 'true' : 'false'" v-for="item in patient.treatment" @click="choosePatientTreatment(item,i)">{{ item.name }}</span>
                            </div>

                            <van-field
                                required
                                label-class="form-title"
                                name="radio"
                                label="所处治疗阶段"
                                :border="false"
                                disabled
                            >
                            </van-field>

                            <div class="form-diagnose">
                                <span :class="item.checked ? 'true' : 'false'" v-for="item in patient.treatment_phase" @click="choosePatientTreatmentPhase(item,i)">{{ item.text }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="line" style="margin-top: 20px"></div>
                    <div class="clear"></div>
                    <div class="add_patients_btn" @click="addPatients">＋ 添加患者</div>
                </div>

                <van-field
                    required
                    label-class="form-title"
                    input-align="right"
                    clickable
                    readonly
                    name="picker"
                    :value="current_patient"
                    label="申请的患者"
                    placeholder="请选择"
                    @click="patientPicker = true"
                    v-if="is_apply && !from_update && formData.identity == 2 && formData.patients.length > 0"
                />
            </div>
            <!--患者家属-->

            <div class="clear"></div>
        </van-form>

        <!--职位-->
        <van-popup v-model="positionPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="position"
                :value-key="'name'"

                @confirm="onPositionConfirm"
                @cancel="positionPicker = false"
            />
        </van-popup>

        <!--身份-->
        <van-popup v-model="identityPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="identityNames"
                :value-key="'title'"
                @confirm="onIdentityConfirm"
                @cancel="identityPicker = false"
            />
        </van-popup>

        <!--选择患者-->
        <van-popup v-model="patientPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="formData.patients"
                :value-key="'name'"
                @confirm="onPickerConfirm"
                @cancel="patientPicker = false"
            >
            </van-picker>
        </van-popup>

        <!--确诊疾病-->
        <van-action-sheet v-model="diagnoseModel" style="height: 550px" title="请选择确诊疾病" safe-area-inset-bottom>
            <van-row class="diagnose-sheet">
                <van-col span="8">
                    <van-sidebar style="height: 400px; overflow-y: scroll;-webkit-overflow-scrolling: touch;box-sizing:border-box;" class="knowledge-list-sidebar" v-model="activeKey" @change="changeSidebar">
                        <van-sidebar-item v-for="item in treeData" :key="item.id" :title="item.name" >
                            <template slot="title">
                                <span style="color: #1fcfc1" v-if="formData.diagnose_parent && formData.diagnose_parent.indexOf(item.name) != -1">{{ item.name }}</span>
                                <span v-else>{{item.name}}</span>
                            </template>
                        </van-sidebar-item>
                    </van-sidebar>
                </van-col>
                <van-col span="16">
                    <div class="knowledge-list-sidebar-section" v-if="treeDataChild.length > 0" style="height: 400px; overflow-y: scroll;-webkit-overflow-scrolling: touch;box-sizing:border-box;">
                        <van-checkbox-group v-model="formData.diagnose" max="3">
                            <van-list>
                                <van-cell v-for="(item,index) in treeDataChild" :key="item.id" :title="item.name" >
                                    <template #right-icon>
                                        <van-checkbox :name="item.id" @click="chooseDiagnose(item,index)" checked-color="#0FB7AD" ref="checkboxs" />
                                    </template>
                                </van-cell>
                            </van-list>
                        </van-checkbox-group>
                    </div>
                </van-col>
                <div class="clear"></div>
            </van-row>
            <div class="diagnose-sheet-footer">
                <div class="diagnose-sheet-footer-text">已选:{{formData.diagnose_name.join(",")}}</div>
                <van-button style="float: right;padding: 6px 20px" color="#0FB7AD" type="info" round @click="diagnoseModel = false">完成</van-button>
            </div>
        </van-action-sheet>

        <!--职务/职称-->
        <van-dialog width="295" v-model="showPositionVisible" title="请填写职务/职称" show-cancel-button @cancel="formData.position=''" @confirm="resetPosition">
            <div class="position-input-box">
                <van-field
                    label-class="position-title"
                    input-align="left"
                    v-model="positionInputValue"
                    name="请填写"
                    placeholder="请填写"
                    ref="savePositionInput"
                    :rules="[{ required: true }]"
                />
            </div>
        </van-dialog>

        <div class="control">
            <van-button class="submit" color="#0FB7AD" round block type="info" native-type="submit" @click="addInfo()">
                完成
            </van-button>
        </div>

        <van-dialog class="add_wechat" v-model="openFeedbackDialog" :showConfirmButton="false">
            <template slot="title">
                <div class="close-pop" @click="reBack">
                    <img src="/static/bytx/popup_close_icon.svg" alt="">
                </div>
                <h3 v-if="from_update">已完善信息!</h3>
                <h3 v-else>您已注册成功！</h3>
            </template>
            <div class="clear"></div>
            <div>
                想了解更多问诊、新药、经济救助、战友群等患友服务，添加小助手
            </div>
            <div class="add_wechat_kf" align="center" style="margin-top: 12px;color: #9D9D9D">
                <img :src="defaultQr" alt="">
                <br>
                长按识别添加
            </div>
        </van-dialog>
    </div>
</template>

<script>

import Interface from "@/util/interface"

export default {
    name: 'home',
    data() {
        return {
            openFeedbackDialog:false,
            defaultQr : "/static/qrcode/default.png",

            value: "",
            active: 1,
            banners: [],
            recommend: [],
            articles: [],
            columns: [],

            hanz: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"],

            formData: {
                name: "",
                sex: "",
                city: "",
                city_id: 0,
                province: "",
                province_id: 0,
                identity: "",
                identity_card_no: "",
                birthday: "",

                position: "",
                hospital: "",
                office_id: 0,
                office: "",
                interested: "",
                email: "",

                identity_name: "",
                diagnose:[],
                diagnose_name:[],
                diagnose_parent:[],
                diagnose_item:[],

                patients: [
                    {
                        id:0,
                        name: "",
                        sex:"",
                        identity_card_no: "",
                        hospital_id: 0,
                        hospital_name: "",
                        current_cure_stage:"",
                        display: true,
                        type : 1,
                        content_id:0,
                    }
                ],
                interested_ids:"",
                cure_method:"",
                cure_method_ids:"",
                current_cure_stage:"",
                delete_patient_ids:"",
            },
            defaultPatient : {
                id:0,
                name: "",
                sex:"",
                identity_card_no: "",
                hospital_id: 0,
                hospital_name: "",
                current_cure_stage:"",
                display: true,
                type : 1,
                content_id:0,
            },

            current_patient:"",
            current_patient_index:0,
            update_patient:false,

            status: false,

            showArea: false,
            areaList: {},

            showPicker: false,

            position: [],
            positionPicker: false,

            city: [],
            cityPicker: false,

            office: [],
            officePicker: false,

            result: [],

            showPositionVisible: false,
            positionInputValue: "",

            currentDate: new Date(1990, 0, 1),
            minDate: new Date(1920, 0, 1),
            maxDate: new Date(),
            showBirthdayPicker: false,


            treatment_phase : [],

            is_apply: false,
            from_update: false,
            firstWarning:false,

            // 疾病
            diagnose: [],
            diagnose_item:[],
            treeData:[],
            treeDataChild:[],
            diagnoseModel: false,
            list :[],
            activeKey:0,

            // 治疗方式
            treatment: [],

            // storage
            source_form : "",

            // 治疗阶段
            treatment_episode:[],

            // 身份
            identityNames : [
                {
                    id: 3,
                    title: "医务工作者",
                },
                {
                    id: 5,
                    title: "医疗企业相关人士",
                },
                {
                    id: 6,
                    title: "公益组织",
                },
                {
                    id: 7,
                    title: "媒体",
                },
            ],
            identityPicker:false,

            // 家属
            patientPicker:false,
            patientNames:[],

        }
    },
    methods: {

        changeSidebar(){
            if(this.treeData[this.activeKey]) {
                this.treeDataChild = this.treeData[this.activeKey].children
            }
        },

        openDiagnoseModel(){
            this.diagnoseModel = true
        },

        openPatientDiagnoseModel(index){
            this.update_patient = true
            this.diagnoseModel = true
            this.current_patient_index = index
            this.formData.diagnose = JSON.parse(JSON.stringify(this.formData.patients[index].diagnose))
            this.formData.diagnose_name = JSON.parse(JSON.stringify(this.formData.patients[index].diagnose_name))
            this.formData.diagnose_parent = JSON.parse(JSON.stringify(this.formData.patients[index].diagnose_parent))
            this.formData.diagnose_item = JSON.parse(JSON.stringify(this.formData.patients[index].diagnose_item))
            this.$forceUpdate()
        },
        onSubmit() {

        },
        fetch(scene) {
            if (scene === 'position') {
                Interface.getData('get', Interface.user.position).then((res) => {
                    this.position = res.data.list
                })
            } else if (scene === 'city') {
                Interface.getData('get', Interface.user.city).then((res) => {
                    this.city = res.data
                })
            } else if (scene === 'office') {
                Interface.getData('get', Interface.user.office, {hospital_id: this.formData.hospital_id}).then((res) => {
                    this.office = res.data
                })
            } else if (scene === 'userinfo') {

                let formData = JSON.parse(sessionStorage.getItem('add-info'))
                if(formData) {
                    this.init()
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                }else{
                    Interface.getData('get', Interface.user.user_info).then((res) => {

                        this.formData = {
                            name: res.data.name,
                            sex: res.data.sex,
                            identity: res.data.identity + "",
                            identity_card_no: res.data.identity_card_no,
                            city: res.data.city,
                            city_id: res.data.city_id,
                            position: res.data.position_name,
                            position_id: res.data.position_id,
                            hospital: res.data.hospital_name,
                            hospital_id: res.data.hospital_id,
                            province_id: res.data.province_id,
                            office_id: res.data.office_id,
                            office: res.data.office_name,
                            email: res.data.email,
                            identity_name: res.data.identity_name,
                            current_cure_stage: res.data.current_cure_stage,
                            current_cure_stage_ids: res.data.current_cure_stage_ids,
                            patients: [],
                            diagnose: [],
                            diagnose_name: [],
                            diagnose_item: [],
                        }

                        let patients = []
                        let patientNames = []
                        if (res.data.patients && res.data.patients.length > 0) {
                            patients = res.data.patients
                            patients.forEach( (item) => {

                                let treatment_phase = JSON.parse(JSON.stringify(this.treatment_phase))
                                treatment_phase.forEach(val => {
                                    val.checked = false
                                })
                                if (item.current_cure_stage != "") {
                                    let current_cure_stage = item.current_cure_stage.split(",")
                                    current_cure_stage.forEach(val=>{
                                        treatment_phase.forEach((v,i)=>{
                                            if(v.text === val){
                                                treatment_phase[i].checked = true
                                            }
                                        })
                                    })
                                }
                                item.treatment_phase = treatment_phase

                                let treatment = JSON.parse(JSON.stringify(this.treatment))
                                treatment.forEach(val => {
                                    val.checked = false
                                })
                                if (item.cure_method != "") {
                                    let cure_method = item.cure_method.split(",")
                                    cure_method.forEach(val=>{
                                        treatment.forEach((v,i)=>{
                                            if(v.name === val){
                                                treatment[i].checked = true
                                            }
                                        })
                                    })
                                }
                                item.treatment = treatment


                                item.diagnose = item.interested_ids.split(",")
                                item.diagnose.map((val,i) => {
                                    item.diagnose[i] = parseInt(val)
                                })
                                item.diagnose_name = item.interested.split(",")
                                item.diagnose_item = []
                                let parent = []
                                item.diagnose.forEach((val, i) => {
                                    let names = item.diagnose_name[i].split("-")
                                    parent.push(names[0])
                                    item.diagnose_item.push({
                                        id: val,
                                        name: item.diagnose_name[i]
                                    })
                                })
                                item.diagnose_parent = parent

                                item.hospital = item.hospital_name
                                item.display = false
                                patientNames.push({
                                    id: item.id,
                                    name: item.name
                                })
                            })
                            patients[0].display = true
                            patientNames.push({
                                id:0,
                                name: "添加新的患者"
                            })

                            this.formData.patients = patients
                            this.patientNames = patientNames
                            this.current_patient = patients[0].name
                        }

                        // 确诊疾病
                        if (res.data.interested != "") {
                            this.formData.diagnose = res.data.interested_ids.split(",")
                            this.formData.diagnose.map((item,i) => {
                                this.formData.diagnose[i] = parseInt(item)
                            })
                            this.formData.diagnose_name = res.data.interested.split(",")

                            let parent = []
                            this.formData.diagnose.forEach((val, i) => {
                                let names = this.formData.diagnose_name[i].split("-")
                                parent.push(names[0])
                                this.formData.diagnose_item.push({
                                    id: val,
                                    name: this.formData.diagnose_name[i]
                                })
                            })
                            this.formData.diagnose_parent = parent
                        }

                        // 治疗方式
                        if (res.data.cure_method != "") {
                            let cure_method = res.data.cure_method.split(",")
                            this.treatment.forEach((val, i) => {
                                cure_method.forEach(item => {
                                    if (item === val.name) {
                                        this.treatment[i].checked = true
                                    }
                                })
                            })

                            this.formData.cure_method = res.data.cure_method
                            this.formData.cure_method_ids = res.data.cure_method_ids
                        }

                        // 治疗阶段
                        if (res.data.current_cure_stage != "") {
                            let current_cure_stage = res.data.current_cure_stage.split(",")
                            current_cure_stage.forEach(val=>{
                                this.treatment_phase.forEach((v,i)=>{
                                    if(v.text === val){
                                        this.treatment_phase[i].checked = true
                                        this.formData.current_cure_stage = v.text
                                        this.formData.current_cure_stage_ids = v.id
                                    }
                                })
                            })
                        }

                        if (res.data.identity == 4){
                            if (res.data.identity_name == '患者本人' || res.data.identity_name == '患者家属'){
                                this.formData.identity_name = ''
                            }
                        }
                        this.loading = false
                        this.changeIdentity()
                    })
                }

            } else if (scene == "diagnose"){
                Interface.getData('get', Interface.user.tags,{type:1,pageSize:999}).then((res) => {

                    if (res.code !== 0) {
                        this.$toast.fail(res.message);
                        return
                    }

                    if(res.data.cureStage && res.data.cureStage.children.length > 0){
                        let treatment_phase = []
                        res.data.cureStage.children.forEach(item => {
                            treatment_phase.push({
                                id: item.id,
                                text: item.name,
                                checked: false,
                            })
                        })
                        this.treatment_phase = treatment_phase
                    }

                    let treeData = []
                    res.data.list.forEach(item => {
                        // 把自己放进去
                        // 如果children为空 , 就把自己放在children里面
                        if(!item.children || item.children.length === 0){
                            item.children = [{
                                id: item.id,
                                name: item.name,
                                checked: false,
                                children: []
                            }]
                        }
                        treeData.push({
                            id: item.id,
                            name: item.name,
                            checked: false,
                            children: item.children
                        })
                    })
                    this.$set(this, 'treeData', treeData)
                    this.changeSidebar()
                    this.fetch('userinfo')
                })
            } else if (scene == "treatment"){
                this.treatment = [
                    {id:64,name:"造血干细胞移植",checked:false},
                    {id:72,name:"CAR-T治疗",checked:false},
                    {id:68,name:"靶向药",checked:false},
                    {id:69,name:"PD-1等免疫抑制剂",checked:false},
                    {id:70,name:"双特异性抗体BITE",checked:false},
                    {id:71,name:"抗体药物偶联物（ADC）",checked:false},
                    {id:63,name:"化疗",checked:false},
                    {id:131,name:"放疗",checked:false},
                    {id:77,name:"手术",checked:false},
                    {id:78,name:"介入治疗",checked:false},
                    {id:283,name:"其他",checked:false},
                ]
            } else if(scene == "treatment_episode"){
                this.treatment_episode = [
                    "化疗中", "即将移植", "已移植", "二次移植", "进展或复发", "结束治疗定期复查", "其他"
                ]
            } else if(scene == "identity"){
                this.identityNames = [
                    {id: 1, title: "医务工作者", checked: false},
                    {id: 2, title: "医疗企业相关人士", checked: false},
                    {id: 3, title: "媒体", checked: false},
                    {id: 4, title: "公益组织", checked: false}
                ]
            }
        },
        onConfirm(values) {
            this.value = values
                .filter((item) => !!item)
                .map((item) => item.name)
                .join('/');
            this.showArea = false;
        },
        chooseOffice() {
            if (this.formData.hospital_id == 0) {
                this.$toast.fail("请选择医院")
                return
            }
            sessionStorage.setItem('add-info', JSON.stringify(this.formData))
            this.$router.push({
                name: "choose-office",
            })
        },
        onPositionConfirm(values, index) {
            this.formData.position = this.position[index[0]].children[index[1]].name
            this.formData.position_id = this.position[index[0]].children[index[1]].id
            this.positionPicker = false;

            if (this.formData.position == '其他') {
                this.showPositionVisible = true
            }
        },

        onIdentityConfirm(values, index) {
            this.formData.identity_name = this.identityNames[index].title
            this.changeIdentityName()
            this.identityPicker = false;
        },

        onPickerConfirm(values, index) {
            this.current_patient = values.name
            this.patientPicker = false;
        },
        resetPosition() {
            if (this.positionInputValue == "") {
                this.$message.fail("职位不能为空")
                return
            }
            this.formData.position = this.positionInputValue
        },
        onCityConfirm(values, index) {
            this.formData.city = values
                .filter((item) => !!item)
                .map((item) => item)
                .join('/');
            this.formData.province_id = this.city[index[0]].id
            this.formData.city_id = this.city[index[0]].children[index[1]].id
            this.cityPicker = false;
        },
        onOfficeConfirm(values, index) {
            this.formData.office = this.office[index].name
            this.formData.office_id = this.office[index].id
            this.officePicker = false;
        },
        chooseHospital() {
            sessionStorage.setItem('add-info', JSON.stringify(this.formData))
            console.log(this.formData)
            sessionStorage.removeItem('add-info-patients-index')
            this.$router.push({
                name: "choose-hospital",
            })
        },
        choosePatientHospital(i) {
            sessionStorage.setItem('add-info', JSON.stringify(this.formData))
            sessionStorage.setItem('add-info-patients-index', i)
            this.formData.hospital_id = this.formData.patients[i].hospital_id
            this.formData.hospital = this.formData.patients[i].hospital
            this.$router.push({
                name: "choose-hospital",
            })
        },
        changeFavorite(values) {
            this.formData.interested = values
                .filter((item) => !!item)
                .map((item) => item)
                .join(',');
        },
        chooseDiagnose(item,index) {

            let id = item.id
            var has = false

            for (let i = 0; i < this.formData.diagnose.length; i++) {
                if (this.formData.diagnose[i] == id) {
                    has = true
                    break
                }
            }

            if(has){
                // 选中
                let delIds = []

                // 单选子类
                this.treeDataChild.forEach(val=>{
                    if(val.id !== item.id){
                        delIds.push(val.id)
                    }
                })
                delIds.forEach(val=>{
                    let i = this.formData.diagnose.indexOf(val)
                    if(i > -1){
                        this.formData.diagnose.splice(i,1)
                        this.formData.diagnose_item.splice(i,1)
                    }
                })
                this.formData.diagnose_item.push({
                    id: id,
                    name: this.treeData[this.activeKey].name+"-"+item.name
                })
            } else {
                // 未选中
                if(this.formData.diagnose.length == 3){
                    this.$toast.fail("最多选择3个")
                    return
                }

                this.formData.diagnose_item.forEach( (val,i)=>{
                    if(val.id == id){
                        this.formData.diagnose_item.splice(i,1)
                    }
                })
            }

            let diagnose = []
            let diagnose_name = []
            let diagnose_parent = []
            this.formData.diagnose_item.forEach(val=>{
                let names = val.name.split("-")
                diagnose_parent.push(names[0])
                if(names[0] != names[1]){
                    diagnose_name.push(val.name)
                }else{
                    diagnose_name.push(names[1])
                }
                diagnose.push(val.id)
            })

            if(this.formData.identity == 1){
                this.formData.diagnose = diagnose
                this.formData.diagnose_name = diagnose_name
                this.formData.diagnose_parent = diagnose_parent
                this.formData.interested = diagnose_name.join(",")
                this.formData.interested_ids = diagnose.join(",")
            } else if(this.formData.identity == 2){
                this.formData.patients[this.current_patient_index].diagnose = diagnose
                this.formData.patients[this.current_patient_index].diagnose_name = diagnose_name
                this.formData.patients[this.current_patient_index].diagnose_parent = diagnose_parent
                this.formData.patients[this.current_patient_index].diagnose_item = JSON.parse(JSON.stringify(this.formData.diagnose_item))
                this.formData.patients[this.current_patient_index].interested = diagnose_name.join(",")
                this.formData.patients[this.current_patient_index].interested_ids = diagnose.join(",")

                this.formData.diagnose = JSON.parse(JSON.stringify(this.formData.patients[this.current_patient_index].diagnose))
                this.formData.diagnose_name = JSON.parse(JSON.stringify(this.formData.patients[this.current_patient_index].diagnose_name))
                this.formData.diagnose_parent = JSON.parse(JSON.stringify(this.formData.patients[this.current_patient_index].diagnose_parent))
                this.formData.diagnose_item = JSON.parse(JSON.stringify(this.formData.patients[this.current_patient_index].diagnose_item))
            }
        },
        toggle(index) {
            this.$refs.checkboxes[index].toggle();
        },
        chooseTreatment(item) {
            item.checked = !item.checked
            let treatment = ""
            let treatmentIds = []
            this.treatment.forEach(val => {
                if (val.checked) {
                    if (treatment === "") {
                        treatment = val.name
                    } else {
                        treatment += "," + val.name
                    }
                    treatmentIds.push(val.id)
                }
            })
            this.formData.cure_method = treatment
            this.formData.cure_method_ids = treatmentIds.join(",")
            sessionStorage.setItem('add-info', JSON.stringify(this.formData))
        },
        choosePatientTreatment(item,index) {
            item.checked = !item.checked
            let treatment = []
            let cure_method_ids = []
            this.formData.patients[index].treatment.forEach(val => {
                if (val.checked) {
                    treatment.push(val.name)
                    cure_method_ids.push(val.id)
                }
            })
            this.formData.patients[index].cure_method = treatment.join(",")
            this.formData.patients[index].cure_method_ids = cure_method_ids.join(",")
            sessionStorage.setItem('add-info', JSON.stringify(this.formData))
        },
        chooseTreatmentPhase(item, index) {
            this.treatment_phase.forEach(val => {
                if(val.text != item.text){
                    val.checked = false
                }else{
                    val.checked = true
                }
            })
            this.formData.current_cure_stage = item.text
            this.formData.current_cure_stage_ids = item.id
            sessionStorage.setItem('add-info', JSON.stringify(this.formData))
        },
        choosePatientTreatmentPhase(item, index) {
            this.formData.patients[index].treatment_phase.forEach(val => {
                if(val.text != item.text){
                    val.checked = false
                }else{
                    val.checked = true
                }
            })
            this.formData.patients[index].current_cure_stage = item.text
            this.formData.patients[index].current_cure_stage_ids = item.id
            sessionStorage.setItem('add-info', JSON.stringify(this.formData))
        },
        init() {
            let formData = JSON.parse(sessionStorage.getItem('add-info'))
            if (formData) {
                this.formData = JSON.parse(sessionStorage.getItem('add-info'))
                if (this.formData.interested != null && this.formData.interested != "") {
                    this.result = this.formData.interested.split(",")
                }
                if (this.formData.cure_method_ids && this.formData.cure_method_ids != ""){
                    this.treatment && this.treatment.forEach(val=>{
                        if(this.formData.cure_method_ids.indexOf(val.id) > -1){
                            val.checked = true
                        }
                    })
                }
                if (this.formData.current_cure_stage != ""){
                    this.treatment_phase && this.treatment_phase.forEach(val=>{
                        if(this.formData.current_cure_stage == val.text){
                            val.checked = true
                        }
                    })
                }

                if (this.formData.patients && this.formData.patients[0] && this.formData.patients[0].id > 0){
                    let patientNames = []
                    this.formData.patients && this.formData.patients.forEach(val=>{
                        patientNames.push({
                            id: val.id,
                            name: val.name
                        })
                    })
                    patientNames.push({
                        id: 0,
                        name: "添加新的患者"
                    })
                    this.patientNames = patientNames
                    if (this.formData.patients && this.formData.patients.length > 0){
                        this.current_patient = this.formData.patients[0].name
                    }
                }
                sessionStorage.removeItem('add-info')
            }
        },
        valuate(params){

            let identifyTest = /^(1[1-5]|2[1-3]|3[1-7]|4[1-6]|5[0-4]|6[1-5]|71|8[1-2])\d{4}(19\d{2}|20\d{2})((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
            let checkTest =  /^(?![0-9]+$)(?!([a-zA-Z])\1+$).{2,}$/;

            let base = [
                {
                    name: "name",
                    msg: "未填写姓名"
                },
                {
                    name:"sex",
                    msg: "未选择性别"
                },
                {
                    name: "identity",
                    msg: "未选择身份"
                }
            ]

            let other = [
                {
                    name: "name",
                    msg: "未填写姓名"
                },
                {
                    name:"sex",
                    msg: "未选择性别"
                },
                {
                    name: "identity",
                    msg: "未选择身份"
                },
                {
                    name: "identity_name",
                    msg: "未选择身份"
                },
                {
                    name: "hospital",
                    msg: "就职单位未填写"
                },
                {
                    name: "position",
                    msg: "职务/职称未填写"
                }
            ]
            if (!checkTest.test(params.name)) {
                this.$toast.fail("姓名不能为纯数字或字母或单个汉字");
                return false;
            }

            if(params.identity < 3){
                // 基础验证
                for (let i = 0; i < base.length; i++) {
                    if (params[base[i].name] == "") {
                        this.$toast.fail(base[i].msg);
                        return false
                    }
                }
                if(params.identity == 1) {
                    if(params.interested_ids == ""){
                        this.$toast.fail("未选择确认疾病");
                        return false;
                    }else if(params.cure_method_ids == ""){
                        this.$toast.fail("未选择治疗方式");
                        return false;
                    }
                }else if(params.identity == 2){
                    let identify = true
                    if (params.patients.length == 0) {
                        this.$toast.fail("未添加患者");
                        return false
                    }


                    for (let i = 0; i < this.formData.patients.length; i++) {
                        let patient = this.formData.patients[i]
                        if(patient.name == ""){
                            this.$toast.fail("患者姓名未填写");
                            identify = false
                            break
                        }else if(patient.interested_ids == ""){
                            this.$toast.fail("未选择确认疾病");
                            identify = false
                            break
                        }else if(patient.cure_method_ids == ""){
                            this.$toast.fail("未选择治疗方式");
                            identify = false
                            break
                        }if (!checkTest.test(patient.name)) {
                            this.$toast.fail("患者姓名不能为纯数字或字母或单个汉字");
                            identify = false
                            break
                        }
                        for (let j = 0; j < this.formData.patients.length; j++) {
                            if(i != j){
                                if(patient.name == this.formData.patients[j].name){
                                    this.$toast.fail("患者姓名重复");
                                    identify = false
                                    break
                                }
                            }
                        }
                        if(!identify){
                            break
                        }
                    }
                    if(!identify){
                        return false
                    }
                }

            }else if(params.identity == 4){
                for (let i = 0; i < other.length; i++) {
                    if (params[other[i].name] == "") {
                        this.$toast.fail(other[i].msg);
                        return false
                    }
                }
                if(!checkTest.test(params.hospital)) {
                    this.$toast.fail("医院/单位不能为纯数字或字母或单个汉字");
                    return false;
                }else if(!checkTest.test(params.position)) {
                    this.$toast.fail("职务/职称不能为纯数字或字母或单个汉字");
                    return false;
                }
            }
            let identifyArray = []

            if(this.is_apply){
                // 患者相关
                if(params.identity == 1){
                    if (!(identifyTest.test(params.identity_card_no))) {
                        this.$toast.fail("身份证号格式错误");
                        return false;
                    }else if(params.hospital == ""){
                        this.$toast.fail("未选择医院");
                        return false;
                    }else if(params.interested_ids == ""){
                        this.$toast.fail("未选择确认疾病");
                        return false;
                    }else if(params.cure_method_ids == ""){
                        this.$toast.fail("未选择治疗方式");
                        return false;
                    }else if(params.current_cure_stage == ""){
                        this.$toast.fail("未选择治疗阶段");
                        return false;
                    }
                }else if(params.identity == 2){
                    // 患者家属
                    var identify = true
                    if (params.patients.length == 0) {
                        this.$toast.fail("未添加患者");
                        return false
                    }
                    for (let i = 0; i < this.formData.patients.length; i++) {
                        let patient = this.formData.patients[i]
                        if(patient.name == ""){
                            this.$toast.fail("患者姓名未填写");
                            identify= false
                        }else if(patient.sex == ""){
                            this.$toast.fail("患者性别未选择");
                            identify= false
                        }else if (!(identifyTest.test(patient.identity_card_no))) {
                            this.$toast.fail("患者身份证号格式错误");
                            identify= false;
                        }else if(patient.hospital_name == ""){
                            this.$toast.fail("未选择医院");
                            identify= false;
                        }else if(patient.interested_ids == ""){
                            this.$toast.fail("未选择确认疾病");
                            return false;
                        }else if(patient.current_cure_stage == ""){
                            this.$toast.fail("未选择治疗阶段");
                            identify= false;
                        }else if(patient.cure_method_ids == ""){
                            this.$toast.fail("未选择治疗方式");
                            return false;
                        }else if (!checkTest.test(patient.name)) {
                            this.$toast.fail("患者姓名不能为纯数字或字母或单个汉字");
                            identify = false;
                        }
                        for (let j = 0; j < this.formData.patients.length; j++) {
                            if(i != j){
                                if(patient.identity_card_no == this.formData.patients[j].identity_card_no){
                                    this.$toast.fail("患者身份证号重复");
                                    return false
                                }
                                if(patient.name == this.formData.patients[j].name){
                                    this.$toast.fail("患者姓名重复");
                                    return false
                                }
                            }
                        }


                        if(!identify){
                            return false
                        }
                    }

                }
            }

            return true
        },
        addInfo() {
            let params = JSON.parse(JSON.stringify(this.formData))

            // 经历治疗
            let cure_method = []
            let cure_method_ids = []
            this.treatment.forEach(val=>{
                if(val.checked){
                    cure_method_ids.push(val.id)
                    cure_method.push(val.name)
                }
            })
            params.cure_method = cure_method.join(",")
            params.cure_method_ids = cure_method_ids.join(",")


            // 治疗阶段
            let treatment_phase = []
            let treatment_phase_ids = []
            this.treatment_phase.forEach(val=>{
                if(val.checked){
                    treatment_phase.push(val.text)
                    treatment_phase_ids.push(val.id)
                }
            })
            params.current_cure_stage = treatment_phase.join(",")
            params.current_cure_stage_ids = treatment_phase_ids.join(",") + ""


            // 确诊疾病
            params.interested = params.diagnose_name.join(",")
            params.interested_ids = params.diagnose.join(",")

            // 申请来源
            let apply = sessionStorage.getItem("apply")
            params.type = 0
            params.content_id = 0
            if (apply) {
                let applyData = JSON.parse(apply)
                let applyType = {
                    "clinic": 7,
                    "diagnose": 11,
                    "community":8,
                    "group": 201,
                }
                params.type = applyType[applyData.apply]
                params.content_id = parseInt(applyData.apply_id)
            }

            // 判断当前角色 ,确认选的 interested , interested_ids 是属于什么
            if(this.formData.identity == 2) {
                // 患者家属
                this.formData.patients.forEach((val, index)=>{
                    if(this.current_patient == val.name) {
                        params.patients[index].content_id = params.content_id
                        params.patients[index].type = params.type
                    }else{
                        params.patients[index].content_id = 0
                        params.patients[index].type = 0
                    }
                    params.patients[index].cure_method_ids = params.patients[index].cure_method_ids + ""
                    params.patients[index].current_cure_stage_ids = params.patients[index].current_cure_stage_ids + ""

                    delete params.patients[index].treatment_phase
                    delete params.patients[index].treatment
                    delete params.display
                })
            }
            delete params.diagnose
            delete params.diagnose_name

            if (!this.valuate(params)){
                return
            }
            params.is_complete = 1
            params.new_reg_complete = 1

            if(params.patients){
                params.patients = JSON.stringify(params.patients)
            }

            if(params.hospital != "" && params.hospital_name == ""){
                params.hospital_name = params.hospital
            }else if(params.hospital == "" && params.hospital_name != ""){
                params.hospital = params.hospital_name
            }

            if (params.identity_name == '医疗企业相关人士' || params.identity_name == '媒体' || params.identity_name == '公益组织') {
                params.hospital_id = 0
            }

            var live_dialog_img = localStorage.getItem("live_dialog_img")
            if (live_dialog_img) {
                params.bind_live_dialog_img = live_dialog_img
            }

            Interface.getData('put', Interface.user.add_info, params).then(res => {
                if (res.code === 0) {
                    sessionStorage.removeItem('add-info')
                    sessionStorage.removeItem('add-info-from')
                    sessionStorage.removeItem('add-info-patients-index')
                    sessionStorage.removeItem('from_update')

                    // 用户完成信息补充
                    localStorage.setItem("user", JSON.stringify(res.data))
                    localStorage.setItem("user_id", res.data.id)
                    localStorage.setItem("new_reg_complete", "1")

                    let apply = sessionStorage.getItem("apply")
                    if (apply) {
                        let applyData = JSON.parse(apply)
                        let apply_qrcode = ""
                        let api = ""
                        switch (applyData.apply) {
                            case 'clinic':
                                apply_qrcode = "/static/qrcode/lczm.png";
                                if (applyData.apply_category_id == "27"){
                                  // 实体肿瘤
                                    apply_qrcode = "/static/qrcode/zm_27.png";
                                }
                                api = Interface.user.apply_clinic + applyData.apply_id;
                                let extend_title = ''
                                if (applyData.apply_title) {
                                  extend_title = applyData.apply_title
                                }
                                let apply_id = 0
                                if (applyData.apply_id) {
                                  apply_id = applyData.apply_id
                                }
                                Interface.mFootPrint(apply_id, 89, 3, 0, 0, '', 0, '临床招募-申请救助-提交', extend_title)
                                break
                            case 'diagnose':
                                apply_qrcode = "/static/bytx/qrcode/zdsj_v2.jpeg";
                                api = Interface.user.apply_diagnose + applyData.apply_id;
                                break
                            case 'community':
                                apply_qrcode = "/static/qrcode/gyjz.png";
                                api = Interface.user.apply_community + applyData.apply_id;
                                break
                            case 'group':
                                apply_qrcode = "/static/bytx/qrcode/zyq_v2.jpeg";
                                api = Interface.user.apply_group + applyData.apply_id;
                                break
                            case 'update':
                                api = "";
                                sessionStorage.removeItem('apply')
                                this.reBack()
                                break
                        }
                        sessionStorage.setItem("apply_qrcode", apply_qrcode)
                        if (api != "") {
                            Interface.getData('get', api).then(resp => {
                                if (resp.code === 0) {
                                    sessionStorage.setItem("init_complete", 1)
                                    sessionStorage.removeItem('apply')
                                    this.reBack()
                                } else {
                                    this.error = true;
                                    this.$toast.fail(resp.message);
                                    sessionStorage.removeItem('apply')
                                    this.reBack()
                                }
                            })
                        }
                    } else {
                        var complete_from = sessionStorage.getItem("complete_from")
                        switch (complete_from){
                            case 'article':
                                this.defaultQr = "/static/qrcode/simple/article.jpg"
                                break
                            case 'live':
                                this.defaultQr = "/static/qrcode/simple/live.jpg"
                                if(live_dialog_img){
                                    this.defaultQr = live_dialog_img
                                }
                                break
                            case 'video':
                                this.defaultQr = "/static/qrcode/simple/video.jpg"
                                break
                            default:
                                this.defaultQr = "/static/qrcode/default.png"
                        }
                        this.openFeedbackDialog = true
                        this.$forceUpdate()
                        if(this.from_update){
                            this.reBack()
                        }
                        this.$forceUpdate()
                    }
                } else {
                    this.error = true;
                    this.$toast.fail(res.message);
                }
            })
        },
        reBack() {
            let back = sessionStorage.getItem("back-url")
            if (back != null) {
                this.$router.push({
                    path: back,
                })
            } else {
                this.$router.push({
                    name: "home",
                })
            }
        },
        clickIdentify(){
            if(this.formData.identity == 1){
                this.formData.identity_card_no = ""
                this.formData.cure_method = ""
                this.formData.cure_method_ids = ""
                this.formData.interested = ""
                this.formData.diagnose_name = []
                this.formData.diagnose = []
                this.formData.diagnose_item = []
                this.formData.diagnose_parent = []
                this.formData.hospital = ""
                this.formData.hospital_id = 0
                this.formData.identity_name = ""
                this.treatment_phase.forEach((val, index)=>{
                    val.checked = false
                })
                this.treatment.forEach((val, index)=>{
                    val.checked = false
                })
            }else if(this.formData.identity == 2){
                this.formData.identity_name = ""
                this.formData.hospital = ""
                this.formData.hospital_id = 0
                this.formData.diagnose_name = []
                this.formData.diagnose = []
                this.formData.diagnose_item = []
                this.formData.diagnose_parent = []
                if(!this.formData.patients || this.formData.patients.length == 0){
                    this.initPatient()
                }
            }else if(this.formData.identity == 4){
                this.formData.hospital = ""
                this.formData.hospital_id = 0
                this.formData.position = ""
                this.formData.identity_name = ""
            }
        },
        changeIdentityName(){
            this.formData.hospital = ""
            this.formData.hospital_id = 0
            this.formData.position = ""
        },
        changeIdentity() {
            this.$forceUpdate()
        },
        initPatient(){
            let apply = sessionStorage.getItem("apply")
            let type = 0
            let content_id = 0

            if (apply) {
                let applyData = JSON.parse(apply)
                let applyType = {
                    "clinic": 7,
                    "diagnose": 11,
                    "community":8,
                    "group": 201,
                }
                type = applyType[applyData.apply]
                content_id = applyData.apply_id
            }
            let treatment_phase = JSON.parse(JSON.stringify(this.treatment_phase))
            treatment_phase.forEach((val, index)=>{
                treatment_phase[index].checked = false
            })
            let treatment = JSON.parse(JSON.stringify(this.treatment))
            treatment.forEach((val, index)=>{
                treatment[index].checked = false
            })
            this.formData.patients.push({
                id:0,
                name: "",
                sex:"",
                identity_card_no: "",
                hospital_id: 0,
                hospital_name: "",
                current_cure_stage:"",
                display: true,
                type : type,
                content_id: parseInt(content_id),
                treatment_phase: treatment_phase,
                treatment:treatment,
                diagnose:[],
                diagnose_parent:[],
                diagnose_name:[],
                diagnose_item:[],
            })
            this.$forceUpdate()
        },
        deletePatient(i){
            if(this.formData.patients.length == 1){
                this.$toast.fail("至少保留一个患者信息")
                return
            }
            this.$dialog.confirm({
                title: '删除确定',
                message: '确认删除吗?删除后该信息将不存在',
                confirmButtonText:"确认"
            }).then(() => {
                let item = this.formData.patients[i]
                if (item.id != 0){
                    if(this.formData.delete_patient_ids == ""){
                        this.formData.delete_patient_ids = item.id+""
                    }else{
                        this.formData.delete_patient_ids+= ","+item.id
                    }
                }
                this.formData.patients.splice(i,1)
            });
        },
        addPatients() {
            let apply = sessionStorage.getItem("apply")
            let type = 0
            let content_id = 0

            if (apply) {
                let applyData = JSON.parse(apply)
                let applyType = {
                    "clinic": 7,
                    "diagnose": 11,
                    "community":8,
                    "group": 201,
                }
                type = applyType[applyData.apply]
                content_id = applyData.apply_id
            }
            let treatment_phase = JSON.parse(JSON.stringify(this.treatment_phase))
            treatment_phase.forEach((val, index)=>{
                treatment_phase[index].checked = false
            })

            let treatment = JSON.parse(JSON.stringify(this.treatment))
            treatment.forEach((val, index)=>{
                treatment[index].checked = false
            })


            this.formData.patients.push({
                id:0,
                name: "",
                sex:"",
                identity_card_no: "",
                hospital_id: 0,
                hospital_name: "",
                current_cure_stage:"",
                display: true,
                type : type,
                content_id: parseInt(content_id),
                treatment_phase: treatment_phase,
                treatment:treatment,
                diagnose:[],
                diagnose_parent:[],
                diagnose_name:[],
                diagnose_item:[],
            })
            this.$forceUpdate()
        },
    },
    created() {
        this.fetch('position')
        this.fetch('city')
        this.fetch('diagnose')
        this.fetch('treatment')
        this.fetch('identity')
        sessionStorage.setItem("complete_from", "live");
        if(this.$route.query.update == "1"){
            this.from_update = true
            let firstWarning = localStorage.getItem("firstWarning")
            if(firstWarning == null){
                this.firstWarning = true
                localStorage.setItem("firstWarning", "1")
            }
        }

        let apply = sessionStorage.getItem("apply")
        if (apply) {
            let applyData = JSON.parse(apply)
            if (applyData.apply == "update") {
                this.from_update = true
            }
            this.is_apply = true
        }
        this.source_form = sessionStorage.getItem("add-info-from")
        Interface.getShareInfo(this, "", "", "")
    }
}
</script>

<style lang="scss">
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/login/add-info/index.vue